var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sls"},[_c('hero',{attrs:{"title":"We're Lost","subtitle":"It's OK. We just need to look up!"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }